import { httpApi } from "./http.api";

export const getSearchResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-companies/?text=${encodeURIComponent(
        text
      )}&industries=1`
    )
    .then((data: any) => data.data);

export const getSearchLog = (page = 1): Promise<any[]> =>
  httpApi
    .post<any[]>(`/search/?search_by_name=False&page=${page}`)
    .then((data: any) => data.data);

export const getSkillSearchResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-skills/?text=${encodeURIComponent(text)}&titles=`
    )
    .then((data: any) => data.data);

export const getUniversitySearchResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-universities/?text=${encodeURIComponent(text)}`
    )
    .then((data: any) => data.data);

export const getEducationLevelResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-education-levels/?text=${encodeURIComponent(
        text
      )}`
    )
    .then((data: any) => data.data);

export const getEducationFieldResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-education-fields/?text=${encodeURIComponent(
        text
      )}`
    )
    .then((data: any) => data.data);

export const getJobTitleResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-job-title/?text=${encodeURIComponent(
        text
      )}&industries=`
    )
    .then((data: any) => data.data);

export const getIndustryResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-companies/?text=${encodeURIComponent(
        text
      )}&search_by_industry=true`
    )
    .then((data: any) => data.data);

export const getIndustryGrpResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-industries/?text=${encodeURIComponent(
        text
      )}&search_by_industry=false`
    )
    .then((data: any) => data.data);

export const getIndustryGrpLeaderResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-industries/?text=${text}&search_by_industry=true`
    )
    .then((data: any) => data.data);
export const getIndustryLeaderResult = (text: string): Promise<any[]> =>
  httpApi
    .get<any[]>(
      `explorator/autocomplete-companies/?text=${encodeURIComponent(
        text
      )}&search_by_industry=false`
    )
    .then((data: any) => data.data);

export const getSearchStats = (search_id: any): Promise<any[]> =>
  httpApi
    .get<any[]>(`explorator/search-stats/?search_id=${search_id}`)
    .then((data: any) => data.data);

export const getCandidateList = (candidateIds: any): Promise<any[]> =>
  httpApi
    .post<any[]>(`candidate/custom-candidates/get-candidates/`, {
      ids: candidateIds,
    })
    .then((data: any) => data.data);

export const getIndustryByType = (data: {
  fortune_100: boolean;
  fortune_500: boolean;
  fortune_1000: boolean;

  text: string;
}): Promise<any[]> =>
  httpApi
    .post<any[]>(`company/fortune-companies/`, data)
    .then((data: any) => data.data);
export const getModelCandidateProfileResult = (payload: any): Promise<any[]> =>
  httpApi
    .post<any[]>(`explorator/ideal-candidate/`, payload)
    .then((data: any) => data.data);

export const startSearching = (
  payload: any,
  config: any = {}
): Promise<any[]> =>
  httpApi
    .post<any[]>(
      `/search/`,
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const updateSearch = (
  searchId: any,
  payload: any,
  config: any = {}
): Promise<any[]> =>
  httpApi
    .patch<any[]>(
      `/search/${searchId}/`,
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const filterSearchResult = (
  payload: any,
  config: any = {}
): Promise<any[]> =>
  httpApi
    .post<any[]>(
      `/search/results/`,
      {
        ...payload,
      },
      { signal: config.signal }
    )
    .then((data: any) => data.data);

export const getMainSearchResult = (
  searchResultId: any,
  search_wizard_config: any = {},
  page: number = 1,
  filterData: any = {}
): Promise<any[]> =>
  httpApi
    .post<any[]>(`/search/results/?page=${page}`, {
      search_id: searchResultId,
      search_wizard_config: search_wizard_config,
      page: page,
      ...filterData,
    })
    .then((data: any) => data.data);

export const getAgencyData = (): Promise<any[]> =>
  httpApi.get<any[]>(`explorator/agency-tree/`).then((data: any) => data.data);

export const getSuggestedSkills = (skills: any) => {
  return httpApi
    .post<any[]>(`explorator/suggest-skills`, skills)
    .then((data: any) => data.data);
};

export const getWebSearch = (candidateId: any) => {
  return httpApi
    .post<any[]>(`/candidate/details/web-search/`, { candidate: candidateId })
    .then((data: any) => data.data);
};

export const deleteSearch = (searchId: any) => {
  return httpApi
    .delete<any[]>(`search/${searchId}/`)
    .then((data: any) => data.data);
};

export const getSearchLogDetails = (searchId: any) => {
  return httpApi
    .get<any[]>(`/search/${searchId}/`)
    .then((data: any) => data.data);
};

export const rejectFromSearch = (rejectPayload: {
  candidates: any[];
  is_rejected: boolean;
  search_id: any;
}) => {
  return httpApi
    .post<any[]>(`/search/action/reject-from-search/`, rejectPayload)
    .then((data: any) => data.data);
};

export const getRecentSearchList = (pageNo = 1): Promise<any[]> =>
  httpApi.get<any[]>(`/search/?page=${pageNo}`).then((data: any) => data.data);

export const getSavedSearch = (page = 1): Promise<any[]> =>
  httpApi
    .get<any[]>(`/search/?is_saved=true&page=${page}`)
    .then((data: any) => data.data);

export const saveSearchMark = (
  searchId: any,
  is_saved: boolean
): Promise<any[]> =>
  httpApi
    .post<any[]>(`/search/action/save-search/`, {
      search_id: searchId,
      is_saved: is_saved,
    })
    .then((data: any) => data.data);

export const searchByName = (
  payload: any,
  search_wizard_config: any = {},
  page: number = 1
): Promise<any[]> =>
  httpApi
    .post<any[]>(`/search/`, {
      ...payload,
      search_wizard_config: search_wizard_config,
      page: page,
      search_by_name: true,
    })
    .then((data: any) => data.data);

export const cancelSearch = (searchId: any): Promise<any[]> =>
  httpApi
    .post<any[]>(`/search/action/cancel-search/`, {
      search_id: searchId,
    })
    .then((data: any) => data.data);
